

























































import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";
import { UserReports } from "@/api/types";
import CompanyLogo from "@/components/Atoms/CompanyLogo/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Rates from "@/components/Molecules/Rates/index.vue";
import { numberWithCommas } from "@/helpers/format-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "CompanyDetailSummary",
  components: {
    CompanyLogo,
    Heading,
    Rates
  },
  props: {
    company: {
      type: Object as PropType<Props["company"]>,
      required: true
    }
  },
  computed: {
    reviewCountText() {
      const count = this.company.user_reports.reduce(
        (acc: number, cur: UserReports) => {
          return acc + cur.count;
        },
        0
      );
      return count ? `${numberWithCommas(count)}件` : "0件";
    }
  }
});
